<div class="container">
  <div class="title">
    <h1 class="span"><span translate>DG-FILE-UPLOAD-COMPONENT</span></h1>
    <a href="{{ doc_url }}"
      ><mat-icon class="span" id="link">attachment</mat-icon></a
    >
  </div>
  <div>
    <mat-card class="card">
      <mat-card-subtitle>Inputs and Events</mat-card-subtitle>
      <mat-card-content class="ps-3">
        <mat-label>Inputs</mat-label>
        <ul>
          <li>[acceptedType]</li>
          <li>[maxfiles]</li>
          <li>[maxSize]</li>
          <li>[multiple]</li>
          <li>[allowFileToAttach]</li>
          <li>[allowDelete]</li>
          <li>[attachId]</li>
          <li>[previousPath]</li>
          <li>[edit]</li>
          <li>[title]</li>
          <li>[profileAttachment]</li>
          <li>[refreshAttachComponent]</li>
          <li>[uniqueAttachmentId]</li>
          <li>[mandatory]</li>
        </ul>
        <mat-label>Events</mat-label>
        <ul>
          <li>(finalPath)</li>
        </ul>
      </mat-card-content>
    </mat-card>
  </div>
  <div>
    <mat-card class="card">
      <ul>
        <li>
          Loaded with default configuration i.e single upload,size,accepted
          types,maximum files etc
        </li>
      </ul>
      <mat-card-content>
        <dg-file-upload
          [title]="attachmentTitleSingle"
          (finalPath)="onFinalPath($event)"
        ></dg-file-upload>
      </mat-card-content>
    </mat-card>
  </div>

  <div>
    <mat-card class="card">
      <mat-card-content>
        <ul>
          <li>Multiple upload allowed</li>
          <li>Specify Title,Maximum Docs, Size, Type</li>
          <li>Provision to Restrict from uploading and deleting Docs</li>
          <li>Load existing Files</li>
        </ul>
        <dg-file-upload
          [multiple]="multipleAllowed"
          [edit]="isEdit"
          [acceptedType]="appAcceptedType"
          [attachId]="130610134"
          [previousPath]="appTempPath"
          [maxSize]="appMaxSize"
          [maxfiles]="appMaxFiles"
          (finalPath)="onFinalPath($event)"
          [title]="attachmentTitle"
          [allowMerging]="false"
          [isPreviewIcon]="true"
          [uniqueAttachmentId]="attachmentID"
          [allowUpdate]="isAllowUpdate"
          [allowFileToAttach]="isAllowFileToAttach"
          [allowDelete]="isAllowDelete"
          [mandatory]="isMandatory"
          [refreshAttachComponent]="isRefresh"
          [allowUpdate]="true"
          [withActions]="true"
          [isPreview]="true"
          [isOnlyOfficeSupported]="true"
          [mappingId]="130615951"
        >
        </dg-file-upload>
      </mat-card-content>
    </mat-card>
  </div>

  <div>
    <mat-card class="card">
      <ul>
        <li>Restrict to Single upload</li>
        <li>Can Specify Size, Type</li>
        <li>Load existing Profile</li>
      </ul>
      <mat-card-content>
        <dg-file-upload
          [title]="profileAttachTitle"
          (finalPath)="onFinalPathForProfile($event)"
          [profileAttachment]="isProfileComponent"
          [acceptedType]="profileAcceptedType"
          [maxSize]="profileMaxSize"
          [allowMerging]="false"
          [uniqueAttachmentId]="profileUniqueAttachID"
          [allowFileToAttach]="isAllowFileToAttachProfile"
          [attachId]="profileAttachID"
          [previousPath]="profileTempPath"
          [allowDelete]="isAllowDelete"
        >
        </dg-file-upload>
      </mat-card-content>
    </mat-card>
  </div>
  <div>
    <mat-card class="card">
      <mat-card-content>
        <ul>
          <li>Multiple upload allowed</li>
          <li>Specify Title,Maximum Docs, Size, Type</li>
          <li>Provision to Restrict from uploading and deleting Docs</li>
          <li>Load existing Files</li>
          <li>Small attachemnt icon</li>
        </ul>
        <dg-file-upload
          [multiple]="multipleAllowed"
          [edit]="isEdit"
          [acceptedType]="appAcceptedType"
          [attachId]=""
          [maxSize]="appMaxSize"
          [maxfiles]="appMaxFiles2"
          (finalPath)="onFinalPath($event)"
          [title]="attachmentTitle"
          [uniqueAttachmentId]="attachmentID"
          [allowUpdate]="isAllowUpdate"
          [allowFileToAttach]="isAllowFileToAttach"
          [allowDelete]="isAllowDelete"
          [mandatory]="isMandatory"
          [refreshAttachComponent]="isRefresh"
          [attachSmall]="attachSmall"
        >
        </dg-file-upload>
      </mat-card-content>
    </mat-card>
  </div>
</div>
